"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStyles = exports.designSystemInputThemeConfig = void 0;
var react_1 = require("@emotion/react");
var constant_1 = require("../../../constant");
var style_1 = require("../../../style");
var variables_1 = require("../../../style/variables");
var Blue = style_1.SixsenseColor.Blue, Gray = style_1.SixsenseColor.Gray, Red = style_1.SixsenseColor.Red, White = style_1.SixsenseColor.White;
var Error = style_1.DesignSystemThemeColor.Error, DSGray = style_1.DesignSystemThemeColor.Gray, Primary = style_1.DesignSystemThemeColor.Primary;
var defaultInputThemeConfig = {
    base: {
        container: {
            default: {
                fontWeight: 400,
                color: Gray.DARK_5,
                border: '1px solid ' + Gray.LIGHT_3,
            },
            hovered: {
                border: '1px solid ' + Blue.DEFAULT,
            },
            focused: {
                outline: '3px solid ' + Blue.LIGHT_5,
                caretColor: Gray.DARK_5,
                border: '1px solid ' + Blue.DEFAULT,
            },
            disabled: {
                color: Gray.LIGHT_1,
                background: Gray.LIGHT_5,
                border: '1px solid ' + Gray.LIGHT_3,
            },
        },
        placeholder: {
            default: {
                color: Gray.LIGHT_1,
            },
        },
    },
    error: {
        container: {
            default: {
                border: '1px solid ' + Red.DEFAULT,
            },
            focused: {
                outline: '3px solid ' + Red.LIGHT_5,
                caretColor: Gray.DARK_5,
                border: '1px solid ' + Red.DEFAULT,
            },
            hovered: {
                border: '1px solid ' + Red.DEFAULT,
            },
        },
    },
};
exports.designSystemInputThemeConfig = {
    base: {
        container: {
            default: {
                backgroundColor: White.DEFAULT,
                borderRadius: 6,
                color: DSGray.DEFAULT,
                border: "1px solid " + DSGray.LIGHT_2,
                alignItems: 'center',
                padding: '0 12px',
                gap: 8,
            },
            hovered: {
                borderColor: Primary.LIGHT_1,
            },
            focused: {
                borderColor: Primary.LIGHT_1,
                boxShadow: "0px 0px 0px 4px " + Primary.LIGHT_4,
            },
            disabled: {
                cursor: 'not-allowed',
                borderColor: DSGray.LIGHT_2,
                backgroundColor: DSGray.LIGHT_4,
            },
        },
        placeholder: {
            default: {
                color: DSGray.LIGHT_1,
            },
        },
        input: {
            default: {
                padding: 0,
                color: DSGray.DARK_4,
                fontSize: style_1.pxToRem(14, 16),
                height: 38,
            },
        },
    },
    error: {
        container: {
            default: {
                borderColor: Error.LIGHT_2,
            },
            hovered: {
                borderColor: Error.LIGHT_1,
            },
            focused: {
                borderColor: Error.LIGHT_1,
                boxShadow: "0px 0px 0px 4px " + Error.LIGHT_4,
            },
        },
    },
};
var createStyles = function (themeName) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    if (themeName === void 0) { themeName = ''; }
    var isTheme6DS = themeName === constant_1.DESIGN_SYSTEM;
    var themeConfig = isTheme6DS ? exports.designSystemInputThemeConfig : defaultInputThemeConfig;
    return {
        container: react_1.css(__assign(__assign({ backgroundColor: White.DEFAULT, borderRadius: 2, overflow: 'hidden', position: 'relative', boxSizing: 'border-box', display: 'inline-flex', minWidth: 100, cursor: 'text', outline: 'none', border: "1px solid " + (isTheme6DS ? DSGray.LIGHT_2 : Gray.LIGHT_3) }, (_b = (_a = themeConfig.base) === null || _a === void 0 ? void 0 : _a.container) === null || _b === void 0 ? void 0 : _b.default), { ':focus-within': __assign({}, (_d = (_c = themeConfig.base) === null || _c === void 0 ? void 0 : _c.container) === null || _d === void 0 ? void 0 : _d.focused), ':hover': __assign({}, (_f = (_e = themeConfig.base) === null || _e === void 0 ? void 0 : _e.container) === null || _f === void 0 ? void 0 : _f.hovered) })),
        errorContainer: react_1.css(__assign(__assign({}, (_h = (_g = themeConfig.error) === null || _g === void 0 ? void 0 : _g.container) === null || _h === void 0 ? void 0 : _h.default), { ':focus-within': __assign({}, (_k = (_j = themeConfig.error) === null || _j === void 0 ? void 0 : _j.container) === null || _k === void 0 ? void 0 : _k.focused), ':hover': __assign({}, (_m = (_l = themeConfig.error) === null || _l === void 0 ? void 0 : _l.container) === null || _m === void 0 ? void 0 : _m.hovered) })),
        disableContainer: react_1.css(__assign(__assign({}, (_p = (_o = themeConfig.base) === null || _o === void 0 ? void 0 : _o.container) === null || _p === void 0 ? void 0 : _p.disabled), { ':hover': {
                border: "1px solid " + (isTheme6DS ? DSGray.LIGHT_2 : Gray.LIGHT_3),
            } })),
        input: react_1.css(__assign(__assign({ flex: 1, color: 'inherit', outline: 'none', border: 'none', width: '100%', cursor: 'inherit', backgroundColor: 'inherit' }, (_r = (_q = themeConfig.base) === null || _q === void 0 ? void 0 : _q.input) === null || _r === void 0 ? void 0 : _r.default), { '::placeholder': {
                color: "var(" + variables_1.RootColor.Gray.LIGHT_1 + ")",
            } })),
        placeholder: react_1.css({
            '::-webkit-outer-spin-button, ::-webkit-inner-spin-button': {
                WebkitAppearance: 'none',
                margin: 0,
            },
            '::placeholder': __assign(__assign({}, (_t = (_s = themeConfig.base) === null || _s === void 0 ? void 0 : _s.placeholder) === null || _t === void 0 ? void 0 : _t.default), { opacity: 1 }),
            ':placeholder-shown': {
                textOverflow: 'ellipsis',
            },
        }),
        centered: react_1.css({
            textAlign: 'center',
        }),
        displayFlex: react_1.css({
            display: 'flex',
        }),
    };
};
exports.createStyles = createStyles;
